import { render, staticRenderFns } from "./TaskWorkDetailsModal.vue?vue&type=template&id=5aec68cc&scoped=true&"
import script from "./TaskWorkDetailsModal.vue?vue&type=script&lang=js&"
export * from "./TaskWorkDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskWorkDetailsModal.vue?vue&type=style&index=0&id=5aec68cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec68cc",
  null
  
)

export default component.exports